import { getFeatureFlags } from 'api/featureFlags'
import { useAuth } from 'contexts'
import { useQuery } from 'react-query'

export const useFeatureFlags = () => {
  const { user } = useAuth()

  const { data: featureFlags, ...rest } = useQuery(
    ['featureFlags', user?.id],
    async () => {
      const flags = await getFeatureFlags()
      return flags
    },
    { refetchOnMount: true, refetchOnWindowFocus: true, initialData: {} }
  )

  return { featureFlags: featureFlags, ...rest }
}
